// Soft Blush Modern — Social Post design #2.
//
// Ported from the Claude Design standalone bundle (posts.jsx PostBlush).
// Renders at a fixed 1080×1080 reference size. Parent (StepSocialFinal)
// scales it via CSS transform.
//
// Visual: warm peach/blush palette, italic display headline, check-mark
// bullets, organic blob holding the product image. Footer pairs a brand
// handle with a pill CTA.

import type { SocialPostSlots } from '@/lib/api';
import './PostBlush.css';

interface PostBlushProps {
  slots: SocialPostSlots;
  productImageUrl: string;
}

export default function PostBlush({ slots, productImageUrl }: PostBlushProps) {
  // Source design splits badge_text on "·" so "4.9 · 12,400 reviews"
  // surfaces as a bold "4.9" inline. Falls back to the full string if the
  // user-edited text doesn't contain the separator.
  const badgeParts = slots.badge_text.split('·');
  const badgeLead = badgeParts.length > 1 ? badgeParts[0].trim() : slots.badge_text;

  return (
    <div className="post-blush">
      <div className="frame-pad">
        <div className="top">
          <div className="eyebrow">{slots.eyebrow}</div>
          <div className="badge">
            <span className="dot">★</span>
            <span><b>{badgeLead}</b> <span className="stars">{slots.badge_stars}</span></span>
          </div>
        </div>
        <div className="core">
          <div>
            <h1 dangerouslySetInnerHTML={{ __html: slots.headline }} />
            <div className="sub">{slots.subhead}</div>
            <ul className="bullets">
              <li><span className="chk">✓</span> {slots.bullet1}</li>
              <li><span className="chk">✓</span> {slots.bullet2}</li>
              <li><span className="chk">✓</span> {slots.bullet3}</li>
            </ul>
          </div>
          <div className="product-wrap">
            <div className="product-blob" />
            <div className="product-slot">
              {productImageUrl ? (
                <img src={productImageUrl} alt="Product" />
              ) : (
                <div className="empty-state">Product image</div>
              )}
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="handle"><span>◆</span> {slots.handle}</div>
          <div className="cta">{slots.cta} <span className="arr">→</span></div>
        </div>
      </div>
    </div>
  );
}
